
(function ($) {
    //vrací jazyk
    function get_lang() {
        if ($("body").hasClass("english")) {
            return "en";
        } else {
            return "cs";
        }
    }

    //produktový scrollbar
    // DOCS: https://idiotwu.github.io/smooth-scrollbar/
    if ($("#scroll_box").length) {
        var Scrollbar = window.Scrollbar;
        var Options = {
            alwaysShowTracks: true,
        };
        Scrollbar.init(document.querySelector("#scroll_box"), Options);
    }

    //přidá separátor do tisícovky
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    //funkce konfigurátoru
    // Honza - smazat a vyzkoušet
    function orderTotalPrice(added) {
        var totalPrice = $("#total_price").data("totalprice")
            ? $("#total_price").data("totalprice")
            : 0;
        var savedPrice = $("#total_price").data("incart")
            ? $("#total_price").data("incart")
            : 0;
        totalPrice =
            parseInt(totalPrice) + parseInt(added) - parseInt(savedPrice);

        $("#total_price .price").html(numberWithCommas(totalPrice));
    }
    
    //funkce vráí
    function get_browser() {

        var ua=navigator.userAgent,tem,M=ua.match(/(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 

        if(/trident/i.test(M[1])){
            tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
            return {name:'IE',version:(tem[1]||'')};
            }   

        if(M[1]==='Chrome'){
            tem=ua.match(/\bOPR|Edge\/(\d+)/)
            if(tem!=null)   {return {name:'Opera', version:tem[1]};}
            }   

        M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}

        return {
            name: M[0],
            version: M[1]
        };

    }

    //funkce
    function iOSversion() {

        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            if (!!window.indexedDB) { return 8; }
            if (!!window.SpeechSynthesisUtterance) { return 7; }
            if (!!window.webkitAudioContext) { return 6; }
            if (!!window.matchMedia) { return 5; }
            if (!!window.history && 'pushState' in window.history) { return 4; }
            return 3;
        }

        return '';

    }

    /* Jednotlivé akce
    ========================================================*/

    //sidebar menu functionality
    jQuery(document).ready(function () {
        //mobilní menu
        $("#mobile-menu li").each(function (index, element) {
            var classes = $(this).attr("class");

            //add arrows to elements with children
            if (classes.indexOf("menu-item-has-children") >= 0) {
                $(this).prepend('<i class="arrow"> </i>');
            }
        });

        //click functionality
        $("#mobile-menu .arrow").click(function () {
            if (
                $("#mobile-menu > .menu-item-has-children").hasClass(
                    "showing-ul"
                )
            ) {
                //exclude this element
                var myParent = $(this).closest(
                    "#mobile-menu > .menu-item-has-children"
                );
                $("#mobile-menu > .menu-item-has-children")
                    .not(myParent)
                    .removeClass("showing-ul")
                    .children(".sub-menu")
                    .slideUp();
            }

            //show signling
            if ($(this).parent().hasClass("showing-ul")) {
                $(this).siblings(".sub-menu").slideUp();
                $(this).parent().removeClass("showing-ul");
            } else {
                //
                $(this).siblings(".sub-menu").slideDown();
                $(this).parent().addClass("showing-ul");
            }
        });

        //sekce kompatibility browserů
        //select chrome under version 28
        if ( get_browser().name == "Chrome" && parseInt(get_browser().version) <= 60 ) {
            jQuery("html").addClass("no-sliding").addClass("old-chrome");
        }
    
        // Select Firefox under 28
        if ( get_browser().name == "Firefox" && parseInt(get_browser().version) <= 60 ) {
            jQuery("html").addClass("no-sliding").addClass("old-firefox");
        }

        // Select Safari under version 8
        if ( get_browser().name == "Safari" && parseInt(get_browser().version) <= 8 ) {
            jQuery("html").addClass("no-sliding").addClass("old-safari");
        }

        // Select IE under 10
        if ( get_browser().name == "Msie" && parseInt(get_browser().version) <= 10 ) {

            jQuery("html").addClass("no-sliding").addClass("old-ie");
        }

        //detect old IOS
        if ( iOSversion() < 10 ) {
            jQuery("html").addClass("no-sliding").addClass("old-iphone");
        }

        // Remove empty P tags created by WP inside of Accordion and Orbit
        jQuery(".accordion p:empty, .orbit p:empty").remove();

        // Adds Flex Video to YouTube and Vimeo Embeds
        jQuery(
            '.entry-content iframe[src*="youtube.com"], .entry-content iframe[src*="vimeo.com"]'
        ).each(function () {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
        });
    });

    //show or hide the top menu
    $(window).on("scroll load", function () {
        if ($(window).scrollTop() >= 50) {
            if (!$("body").hasClass("scrolled")) {
                $("body").addClass("scrolled");
                $("#main-menu-container").hide().fadeIn();
            }

            //reverse it back
        } else if ($(window).scrollTop() < 50) {
            if ($("body").hasClass("scrolled")) {
                $("body").removeClass("scrolled");
            }
        }
    });

    //resize equalizer resize
    jQuery(window).on("resize", function () {
        //fire up foundation
        if ($("[data-equalizer]").length) {
            Foundation.reInit("equalizer");
        }
    });

    //ready state
    $(document).ready(function () {
        //fire up foundation
        jQuery(document).foundation();

        //slideout menu
        if ($("#menu").length > 0) {
            var slideout = new Slideout({
                panel: document.getElementById("panel"),
                menu: document.getElementById("menu"),
                padding: 256,
                side: "right",
                tolerance: 70,
            });
        }

        $(".js-slideout-toggle, .slideout-menu .close-button").on(
            "click",
            function () {
                slideout.toggle();
            }
        );

        //cookie lišta
        var cookieconsent = initCookieConsent();
        cookieconsent.run({
            current_lang: get_lang(),
            page_scripts: true,
            autorun: true,
            delay: 0,
            autoclear_cookies: true,
            theme_css:
                globaldata.theme_url +
                "/assets/styles/specific-css/cookiebanner.css",
            gui_options: {
                consent_modal: {
                    layout: "cloud", // box/cloud/bar
                    position: "bottom center", // bottom/top + left/right/center
                    transition: "slide", // zoom/slide
                },
                settings_modal: {
                    layout: "box", // box/bar
                    transition: "slide", // zoom/slide
                },
            },

            onAccept: function (cookies) {
                if (cookieconsent.allowedCategory("necessary")) {
                    var dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "CookieConsent",
                        consentType: "necessary",
                    });
                }

                if (cookieconsent.allowedCategory("tracking")) {
                    var dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "CookieConsent",
                        consentType: "tracking",
                    });
                }

                if (cookieconsent.allowedCategory("performance")) {
                    var dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "CookieConsent",
                        consentType: "performance",
                    });
                }
            },

            languages: {
                en: {
                    consent_modal: {
                        title: globaldata.title,
                        description: globaldata.consent_description,
                        primary_btn: {
                            text: globaldata.primarybtn_text,
                            role: "accept_all", //'accept_selected' or 'accept_all'
                        },
                        secondary_btn: {
                            text: globaldata.secondarybtn_text,
                            role: "settings", //'settings' or 'accept_necessary'
                        },
                        third_btn: {
                            text: globaldata.thirdbtn_text,
                            role: "accept_necessary", //'accept_necessary'
                        },
                    },
                    settings_modal: {
                        title: globaldata.title,
                        save_settings_btn: globaldata.pref_btn_text,
                        accept_all_btn: globaldata.primarybtn_text,
                        reject_all_btn: globaldata.thirdbtn_text,
                        close_btn_label: globaldata.cookie_close_btn_text,
                        cookie_table_headers: [
                            { col1: globaldata.cookie_table_header1 },
                            { col2: globaldata.cookie_table_header2 },
                        ],
                        blocks: [
                            {
                                title: globaldata.cookiemaintitle,
                                description: globaldata.block_description,
                            },
                            {
                                title: globaldata.func_cookie_title,
                                description: globaldata.func_cookie_desc,
                                toggle: {
                                    value: "necessary",
                                    enabled: true,
                                    readonly: true,
                                },
                                cookie_table: [
                                    {
                                        col1: "cc_cookie",
                                        col2: globaldata.func_cookie_table2,
                                    },
                                    {
                                        col1: "_cart_data",
                                        col2: globaldata.card_data,
                                    },
                                    {
                                        col1: "PHPSESSID",
                                        col2: globaldata.phpsessid,
                                    },
                                ],
                            },
                            {
                                title: globaldata.anal_cookie_title,
                                description: globaldata.anal_cookie_desc,
                                toggle: {
                                    value: "performance",
                                    enabled: true,
                                    readonly: false,
                                },
                                cookie_table: [
                                    {
                                        col1: "_ga/_ga*, _gid",
                                        col2: globaldata.anal_cookie_table_desc1,
                                    },
                                    {
                                        col1: "_gcl_au",
                                        col2: globaldata.anal_cookie_table_desc2,
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
        });

        if (!cookieconsent.validCookie("cc_cookie")) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: "CookieConsent",
                consentType: "empty",
            });
        }
        var el = $('#c-inr-i #c-txt .cc-link').remove();
        el.removeClass('cc-link').addClass('c-bn rj-all');
        $('#cm #c-bns').append(el);
        $('.rj-all').on('click', function() { $('#s-rall-bn').click(); });
        
    });

    //tato funkce by měla být v order-proces.js, ale hází zam chybu funkce clickday
    $(document).ready(function () {
        if ($(".calendar-picker").length) {
            const t = new Date();
            const date = ("0" + t.getDate()).slice(-2);
            const month = ("0" + (t.getMonth() + 1)).slice(-2);
            const year = t.getFullYear();
            const time = year + "-" + month + "-" + date;
            var dd = t.getDate()+5;
            var mm = t.getMonth()+1; 
            var yyyy = t.getFullYear();
            if(dd<10) {
                dd='0'+dd;
            } 
            if(mm<10) {
                mm='0'+mm;
            } 
            const availableTime = yyyy+'-'+mm+'-'+dd;
            const selectedDate = globaldata.selected_date;
            const calendar = new VanillaCalendar(".calendar-picker", {
                type: "default",
                date: {
                    today: new Date(time),
                    min: availableTime,
                },
                settings: {
                    lang: "cs",
                    iso8601: true,
                    selection: {
                        day: "single",
                    },
                    visibility: {
                        templateHeader: "%M%Y",
                        monthShort: false,
                        weekNumbers: false,
                        weekend: false,
                        today: true,
                        disabled: true,
                    },
                    selected: {
                        dates: [selectedDate],
                    },
                },
                actions: {
                    clickDay(e, dates) {
                        $("#funeral_date_timestamp").attr("value", function () {
                            return Date.parse(e.target.dataset.calendarDay);
                        });

                        $("#funeral_date").attr("value", function () {
                            return e.target.dataset.calendarDay;
                        });
                    },
                },
            });

            calendar.init();
        }
        function ajax_call_calendar(date) {
            if ($(".meeting_place").is(":checked")) {
                var location = $("input[name='meeting_place']:checked").attr(
                    "id"
                );
                $.ajax({
                    url: globaldata.ajaxurl,
                    type: "post",
                    data: {
                        action: "free_post",
                        date: date,
                        location: location,
                    },

                    success: function (result, data, xhr) {
                        $(".meet_times").empty();
                        var blkstr = [];
                        
                        $.each(result.data[0], function (idx2, val2) {
                          
                            var str = val2;
                            blkstr.push(str);
                        });
                        if (blkstr.length !== 0) {
                            $("#meet_times").show();
                            $.each(blkstr, function (index, value) {
                                //$('.meet_times').append('<div class="meet_time"><a>'+value+'</a></div>');
                                $(".meet_times").append(
                                    '<option class="meet_time" value="' +
                                        value +
                                        '">' +
                                        value +
                                        "</option>"
                                );
                            });
                            $(".no_meet").hide();
                        } else {
                            $("#meet_times").hide();
                            $(".no_meet").show();
                        }
                    },
                    error: function (result) {
                        console.log(result);
                    },
                });
            }
        }

        if ($("#calendar_meet").length) {
            const t = new Date();
            const date = ("0" + t.getDate()).slice(-2);
            const month = ("0" + (t.getMonth() + 1)).slice(-2);
            const year = t.getFullYear();
            const time = year + "-" + month + "-" + date;
            const selectedDate = globaldata.selected_date;
            $("#meet_times").hide();

            const calendar = new VanillaCalendar("#calendar_meet", {
                type: "default",
                date: {
                    today: new Date(time),
                    min: time,
                },
                settings: {
                    lang: "cs",
                    iso8601: true,
                    selection: {
                        day: "single",
                    },
                    visibility: {
                        templateHeader: "%M | %Y",
                        monthShort: false,
                        weekNumbers: false,
                        weekend: false,
                        today: true,
                        disabled: true,
                        time: true,
                    },
                    selected: {
                        dates: [selectedDate],
                        time: true,
                    },
                },
                actions: {
                    clickDay(e, dates) {
                        globaldata.targetDate = e.target.dataset.calendarDay;
                        $(".funeral_date").val(e.target.dataset.calendarDay);
                        ajax_call_calendar(e.target.dataset.calendarDay);

                        // $("#funeral_date_timestamp").attr("value", function () {
                        //     return Date.parse(e.target.dataset.calendarDay);
                        // });

                        // $("#funeral_date").attr("value", function () {

                        //     return e.target.dataset.calendarDay;
                        // });
                    },
                },
            });

            calendar.init();
            $(".meeting_place").on("change click", function () {
                ajax_call_calendar($(".funeral_date").val());
            });
            setInterval(function () {
                $(".meet_times").on("change click", function () {
                    var time = $(this).val();

                    $(".funeral_time").val(time);
                });
            }, 1000);
        }
    });

    jQuery(window).on("load", function () {
        if ($(".slider-for").length) {
            $(".slider-for.history").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<span class="slick-arrow slick-prev"></span>',
                nextArrow: '<span class="slick-arrow slick-next"></span>',
                fade: true,
                asNavFor: ".slider-nav.history",
            });
            $(".slider-nav.history").slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                asNavFor: ".slider-for.history",
                dots: false,
                arrows: false,
                centerMode: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                ],
            });
            $(".slider-for.today").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<span class="slick-arrow slick-prev"></span>',
                nextArrow: '<span class="slick-arrow slick-next"></span>',
                fade: true,
                asNavFor: ".slider-nav.today",
            });
            $(".slider-nav.today").slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                asNavFor: ".slider-for.today",
                dots: false,
                arrows: false,
                centerMode: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                ],
            });
        }

        if (jQuery(".digi-block-quote-slider").length > 0) {
            jQuery(".digi-block-quote-slider").slick({
                arrows: true,
                dots: false,
                //infinite: true,
                fade: false,
                speed: 1000,
                //variableWidth: false,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: false
                      }
                    },
                    {
                      breakpoint: 700,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                      }
                    }
                   
                ]
            });
        }
    });

    jQuery(window).on('load resize', () => {
        if ( $(".digi-block-card-slider").length > 0 && $(window).width() < 640 ) {
            jQuery(".digi-block-card-slider").slick({
                arrows: true,
                dots: false,
                infinite: true,
                fade: false,
                speed: 1000,
                prevArrow: '<span class="slick-prev"></span>',
                nextArrow: '<span class="slick-next"></span>',
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '5%',
            });
        } else {
            if ($(".digi-block-card-slider").length > 0 && $('.digi-block-card-slider').hasClass('slick-initialized')) {
                $('.digi-block-card-slider').slick('unslick');
            }
        }
    });

    

    $(document).ready(function () {
        function checkInView(elem, partial) {
            var container = $(".content-box, main, #body_container");
            var contHeight = container.height();
            var contTop = container.scrollTop();
            var contBottom = contTop + contHeight;

            var elemTop = $(elem).offset().top - container.offset().top;
            var elemBottom = elemTop + $(elem).height();

            var isTotal = elemTop >= 0 && elemBottom <= contHeight;
            var isPart =
                ((elemTop < 0 && elemBottom > 200) ||
                    (elemTop > 0 && elemTop <= container.height())) &&
                partial;

            return isTotal || isPart;
        }
        if ($(window).width() > 1024) {
            $(".shadowed-box, #body_container").on(
                "scroll load resize",
                function () {
                    $.each($(".content-side"), function (i, e) {
                        if (checkInView($(e), false) != false) {
                            var visible_content_id = $(e).attr("id");
                            $(
                                ".aside-box[data-id=" + visible_content_id + "]"
                            ).removeClass("hiden");
                            $(
                                ".aside-box[data-id=" + visible_content_id + "]"
                            ).addClass("in_viewport");
                            if (
                                $(
                                    ".aside-box[data-id=" +
                                        visible_content_id +
                                        "]"
                                ).data("id") > 2
                            ) {
                                $("footer").css({ opacity: 1 });
                            } else {
                                $("footer").css({ opacity: 0 });
                            }
                        } else if (checkInView($(e), false) == false) {
                            var hiden_content_id = $(e).attr("id");
                            $(
                                ".aside-box[data-id=" + hiden_content_id + "]"
                            ).removeClass("in_viewport");
                            $(
                                ".aside-box[data-id=" + hiden_content_id + "]"
                            ).addClass("hiden");
                        }
                    });
                }
            );
        }
        if ($(window).width() > 1024) {
            $("main, #body_container").on(
                "ready load scroll resize",
                function () {
                    $.each($(".content-box"), function (i, e) {
                        if (checkInView($(e), true) != false) {
                            $(e).parent().find("figure").addClass("is_hiden");
                            $(e).find("figure").removeClass("is_hiden");
                            $(e).find("figure").addClass("is_visible");
                        } else if (checkInView($(e), true) == false) {
                            $(e).find("figure").removeClass("is_visible");
                            $(e).find("figure").addClass("is_hiden");
                        }
                    });
                }
            );
        }
        if ($(window).width() > 1024) {
            $("main, .shadowed-box, #body_container").on("scroll", function () {
                var position = $(this).scrollTop();
                if (position > 30) {
                    $("#scroll-helper").removeClass("scroll-visible");
                } else {
                    $("#scroll-helper").addClass("scroll-visible");
                }
            });
            $("main, #body_container").on(
                "ready load resize scroll",
                function () {}
            );
        }

        if ($(window).width() > 1024) {
            Scrollable_element = $(".shadowed-box");
            $("#scroll-button").on("click", function () {
                Scrollable_element.animate({ scrollTop: 0 }, 500);
            });
        } else {
            Scrollable_element = $("#body_container");
            $("#scroll-button").on("click", function () {
                Scrollable_element.animate({ scrollTop: 0 }, 500);
            });
        }

        if ($(window).width() < 640) {
            $('.slideout-menu').css("display", "flex");
        }
        

        if ($(window).width() < 1024) {
            $("main, #body_container").on(
                "ready load scroll resize",
                function () {
                    $.each($(".single-foto"), function (i, e) {
                        if (checkInView($(e), true) != false) {
                            var img = $(e).children("img");
                            var src = img.data("lazyimg");
                            if (src !== undefined && src !== "") {
                                if (!img.hasClass("lazy-loaded")) {
                                    img.attr("src", src).addClass(
                                        "lazy-loaded"
                                    );
                                }
                            }
                        }
                    });
                }
            );
        }
        $(".right_side-scroll input").on("focus", function () {
            $("#overflow-box").animate(
                {
                    scrollTop: $(this).offset().top + "px",
                },
                "fast"
            );
        });

        $('.wpcf7 input[type="checkbox"]').on("click", function () {
            if ($(this).prop("checked") == true) {
                $(".calendar-wrap").addClass("visible");
            } else {
                $(".calendar-wrap").removeClass("visible");
            }
        });
        $(".close_calendar").on("click", function () {
            $(".calendar-wrap").removeClass("visible");
        });
    });

    $(window).on("load change", function () {
        if ($(".callout.alert").length > 0) {
            setTimeout(function () {
                $(".callout.alert").fadeOut(1200);
            }, 4000);
        } else if ( $(".process_warning.callout").length > 0 ) {
            setTimeout(function () {
                $(".process_warning.callout").fadeOut(1200);
            }, 4000);
        }
    });

    if ( $(".process_warning.callout").length > 0 ) {
        $(".process_warning.callout .close").on('click', function(){
            $(".process_warning.callout").fadeOut();
        });
    }

    $(window).on('load', function(){
        if ($('.page-template-template-order-proccess, .page-template-template-configurator').length > 0 && window.location.search === '') {
            if ($('#total_price .price').text() === '0' ) {
                $('#total_price').hide();
            } else {
                $('#total_price').show();
            }
        }
    });
})(jQuery);

